import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';
import { getActiveContentTabTitle } from '../../store/selectors/content';
import { getAppDisplayName } from '../../store/selectors/session';

const messages = defineMessages({
  appName: {
    id: 'core.header.appName',
    defaultMessage: 'Console',
  },
  documentTitle: {
    id: 'core.title.documentTitle',
    defaultMessage: '{routeTitle} - {appName}',
  },
  documentContentTitle: {
    id: 'core.title.documentContentTitle',
    defaultMessage: '{contentTitle} - {routeTitle} - {appName}',
  },
  root: {
    id: 'core.title.routes.root',
    defaultMessage: 'Login',
  },
  notFound: {
    id: 'core.title.routes.notFound',
    defaultMessage: 'Not Found',
  },
} as const);

interface Props {
  children: any;
}

const Main: React.FC<Props> = ({ children }) => {
  const intl = useIntl();
  const location = useLocation();
  const appDisplayName = useAppSelector(getAppDisplayName);
  const contentTitle = useAppSelector(getActiveContentTabTitle);

  useEffect(() => {
    const routeSegment = location.pathname.split('/')[1];
    const route = (routeSegment as keyof typeof messages) || 'root';
    const appName = intl.formatMessage(messages.appName);
    const routeTitle =
      routeSegment === 'app'
        ? appDisplayName
        : intl.formatMessage(messages[route] || messages.notFound);
    window.document.title = intl.formatMessage(
      contentTitle ? messages.documentContentTitle : messages.documentTitle,
      {
        contentTitle,
        routeTitle,
        appName,
      }
    );
  }, [appDisplayName, contentTitle, intl, location.pathname]);

  return children || <div />;
};

export default Main;
